export default __webpack_public_path__ + "media/Jira_left.93fc76543e9a18b7f07427200076e789.svg";